import { StyledButton } from "./styles";

export function Button({
  children,
  size,
  buttonStyle,
  color = "#0d97ea",
  ...props
}) {
  return (
    <StyledButton
      size={size}
      buttonStyle={buttonStyle}
      color={color}
      {...props}
    >
      {children}
    </StyledButton>
  );
}